<template>
  <RouterLink
    :to="route"
    class="module-result"
    active-class="active-router-link"
    :style="moduleResultStyle"
  >
    <div
      class="result"
      @click="closeMenuAndClearOmniSearch"
    >
      <div class="path">
        {{ result.module.moduleCategory.categoryName }}
        <SvgIcon
          class="divider"
          :data="require('@icons/streamline-icons/Outline version/52-Arrows-Diagrams/01-Arrows/arrow-right-1.svg')"
        />
        {{ result.module.moduleName }}
      </div>
      <div class="title">
        <div
          class="icon-ball"
          :style="iconBallStyle"
        >
          <SvgIcon :data="result.module.moduleCategory.icon" />
        </div>
        <span>
          {{ result.moduleName }}
        </span>
      </div>
    </div>
  </RouterLink>
</template>

<script>

import MutationTypes from '@/store/constants/mutations';
import { mapGetters } from 'vuex';
import GetterTypes from '@/store/constants/getters';

export default {
  name: 'OmniSearchModuleResult',
  props: {
    result: {
      type: Object,
      required: true,
    },
    route: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      GetterTypes.OMNI_SEARCH_EVENT_BUS,
    ]),
    moduleResultStyle() {
      return { backgroundColor: `${this.result.module.moduleCategory.color}13` };
    },
    iconBallStyle() {
      return { backgroundColor: this.result.module.moduleCategory.color };
    },
  },
  methods: {
    closeMenuAndClearOmniSearch() {
      this.omniSearchEventBus.emit('clear');
      this.$store.commit(MutationTypes.SET_SHOW_MENU, false);
    },
  },
};
</script>

<style lang="scss" scoped>
  .module-result {
    &.active-router-link {
      .result {
        padding-left: 0.8em;
        box-shadow: 0 0 6px 2px rgba(var(--shadow-color-rgb), 0.32), 0 3px 2px rgba(var(--shadow-color-rgb), 0.3);
      }
    }

    &:hover {
      &:not(.active-router-link) {
        .result {
          padding-left: 0.6em;
        }
      }
    }

    height: 100%;

    .result {
      transition: all 0.2s;
      padding: 0.85em 0.5em;
      display: grid;
      grid-template-rows: repeat(2, min-content);
      align-items: center;
      grid-gap: 0.4em;
      box-shadow: 0 0 3px 2px rgba(var(--shadow-color-rgb), 0.12), 0 1px 2px rgba(var(--shadow-color-rgb), 0.24);

      .path {
        color: var(--primary-text-discrete-hex);
        font-size: 0.7em;

        .divider {
          font-size: 0.6em;
          margin: 0 0.1em;
        }
      }

      .title {
        font-weight: 500;
        display: grid;
        grid-template-columns: repeat(2, max-content);
        grid-gap: 0.7em;
        align-items: center;

        .icon-ball {
          color: var(--accent-text-alt-color-hex);
          padding: 5px;
          border-radius: 100%;
          width: 0.8em;
          height: 0.8em;
          font-size: 1em;
          display: flex;
          justify-items: center;
          align-items: center;
        }
      }
    }
  }
</style>
